/// <amd-module name="Environments/EnvironmentTraceabilityWorkItems/Components/WorkItemsViewComponent" />
import React = require("react");
import { Utilities } from "Traceability/Common/Utilities";
import { IWorkItemsViewData, IWorkItemsViewService } from "Environments/EnvironmentTraceabilityWorkItems/Common/WorkItemViewService.types";
import * as Constants from "Environments/EnvironmentTraceabilityWorkItems/Common/Constants";
import { IArtifactServerObject, IWorkItemsCardProps, WorkItemRef } from "Traceability/WorkItems/Types";
import { WorkItemsCard } from "Traceability/WorkItems/WorkItemsCard";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { getAssetLocation } from "VSS/Platform/Location";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { Card } from "VSSUI/Card";
import { ZeroData } from "VSSUI/ZeroData";
import * as Resources from "Environments/EnvironmentTraceabilityWorkItems/Resources";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

class WorkItemsViewComponent extends VssComponent {
    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this._service = this.context.pageContext.getService<IWorkItemsViewService>("IWorkItemsViewService");
    }

    public render(): JSX.Element {
        const pageData = this._service.pageData;
        if(pageData && pageData.artifactsData && pageData.artifactsData.length < 1 ){
            return this._getZeroDataContentForFilters();
        } 
        const cards = this._getWorkItemsCards(pageData);

        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="traceability-page">
                    <div className="page-content page-content-top">{cards}</div>
                </Page>
            </Surface>
        );
    }

    public componentDidMount(): void{
        super.componentDidMount();
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        const artifactsData = this._service.pageData && this._service.pageData.artifactsData || [];
        telemetryService.publishEvent("Traceability", "Environments.WorkItemsTab", {cardsDisplayed: artifactsData.length});
    }

    private _getWorkItemsCards(pageData: IWorkItemsViewData): JSX.Element[] {
        let cards: JSX.Element[] = [];
        const artifactsData = pageData && pageData.artifactsData || [];
        const hideCardTitle = artifactsData.length === 1;
        (pageData && pageData.artifactsData || []).forEach((artifactData: IArtifactServerObject<WorkItemRef>, index: number) => {
            const artifactDetails = Utilities.getArtifactDetailsObject<WorkItemRef>(artifactData, pageData.currentRunId);
            const cardProps: IWorkItemsCardProps<WorkItemRef> = {
                cardIndex: index,
                innerErrorMessage: artifactData.innerErrorMessage,
                artifactDetails: artifactDetails,
                data: artifactData.data || [],
                workItemTypes: this._service.getWorkItemTypes(artifactDetails),
                getPipelineTypeWorkItems: true,
                getCardData: this._service.getWorkItems,
                hideCardTitle: hideCardTitle
            };

            cards.push(
                <div key={index} className="page-content-bottom">
                    <WorkItemsCard key={index} {...cardProps} />
                </div>
            );
        });

        return cards;
    }

    private _getZeroDataContentForFilters(): JSX.Element {
        const image = getAssetLocation(this.context.pageContext, "ms.vss-environments-web/environment-rundetails/Content/no-results.png");
        return (
            <Card className="flex-grow bolt-card-no-vertical-padding environment-minimum-card-height" contentProps={{ contentPadding: false }}>
                <div className="zero-data-container">
                    <ZeroData
                        imageAltText={Resources.NoWorkitems}
                        imagePath={image}
                        secondaryText={Resources.NoWorkitems}
                        className={"zero-data-content"}
                    />
                </div>
            </Card>
        )
    }

    private _service: IWorkItemsViewService;
}

Components.add("WorkItemsViewComponent", WorkItemsViewComponent);
